import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';

import * as _ from 'lodash';

@Component({
    selector: 'app-tabit-order-extras',
    templateUrl: './tabit-order-extras.component.html',
    styleUrl: './tabit-order-extras.component.scss',
    standalone: false
})
export class TabitOrderExtrasComponent implements OnInit {
	@Output() onNext = new EventEmitter<any>();
	@ViewChild('extraForm') public extraForm: NgForm;

	$storage;
	extraOffers: any;
	extraFormSubmitted: boolean = false;

	constructor(
		public app: AppService,
		public orderService: OrderService,

	) {
		this.$storage = this.orderService.$storage;
		this.extraOffers = this.$storage.extraOffersParsed;
	}

	ngOnInit(ev?) {}

	continue() {
		try {
			this.extraFormSubmitted = true;
			this.extraForm.onSubmit(undefined);
		} catch (e) { }

		if (!this.extraForm.valid) {
			return;
		} else if (this.extraOffers.groups) {
			let groupErrorsArray = [];
			_.each(this.extraOffers.groups, group => {
				if (group.requireSelection && !group.count) {
					groupErrorsArray.push(group.$minMessage);
				}
			});
			if (groupErrorsArray.length) {
				this.app.alert({ content: groupErrorsArray.join('\n') });
				return;
			}
		}

		let extraOffers = [], extraGroups = [];
		_.each(this.extraOffers.offers, (_offer) => {
			if (_offer.count > 0) extraOffers.push(_offer);
		});
		_.each(this.extraOffers.groups, (_group) => {
			if (_group.count > 0) extraGroups.push(_group);
		});

		this.$storage.selectedExtraOffers = extraOffers;
		this.$storage.selectedExtraOffersGroups = extraGroups;

		this.onNext.emit({});
	}

	//------------------------------------------------------------------------------------>
	// extra offers
	//------------------------------------------------------------------------------------>

	addExtraOffer(_offer, op) {
		let newVal = _offer.count + op;
		if (newVal < 0 || newVal > _offer.maxCount) return;
		_offer.count = newVal;
	}

	addGroupOffer(group, _offer, op) {
		let newVal = group.count + op;
		if (newVal < 0 || newVal > group.maxCount) return;
		_offer.count = _offer.count + op;
		group.count = newVal;
	}

}
